import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3" }

import { computed } from 'vue';
    import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { useCreditCardData } from '@/composables/useCreditCardData';
    import { useI18n } from 'vue-i18n';
    import { usePage, router } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    // import { Button } from '@/components/ui/button';
    // import { Plus } from 'lucide-vue-next';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeCreditCardsForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();

    const { creditCards } = useCreditCardData(selectedCompanyId.value);

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "credit_cards",
      label: "employee.credit_cards.assigned"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          id: "credit_cards",
          modelValue: _ctx.form.credit_cards,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.credit_cards) = $event)),
          options: _unref(creditCards),
          "label-by": "name",
          "value-by": "id",
          placeholder: _unref(t)('employee.credit_cards.assigned')
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})